//#region imports
import React from 'react';
import Container from '@mui/material/Container';
import styles from './styles';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import Button from '@mui/material/Button';
import { RULE_URLS } from 'configs/constants';
import Typography from '@mui/material/Typography';
import useMobile from 'hooks/useMobile';
import PrizeFondTable from './components/Table';
//#endregion

interface IProps {
  className?: string;
  currentNumber: number;
}

const PrizeFond: React.FC<IProps> = ({ className, currentNumber }) => {
  const { t } = useTranslation();
  const classes = styles();
  const { isMobile } = useMobile();

  return (
    <Container className={ cn(className, classes.root, 'slim') } id="prizes">
      <Typography
        variant="h2"
        fontSize={ isMobile ? 26 : 30 }
        color="inherit"
        mb={ isMobile ? 4 : 8 }
        dangerouslySetInnerHTML={ { __html: t(`prizeFond.title.${currentNumber}`) } }
      />

      <PrizeFondTable className={ classes.table } currentNumber={ currentNumber }/>
      <Button className={ classes.button } LinkComponent={ 'a' } variant="contained" color="primary" target="_blank" rel="noreferrer" href={ RULE_URLS[currentNumber] }>
        { t('action.rule') }
      </Button>
    </Container>
  );
};

export default PrizeFond;
